// extracted by css-extract-rspack-plugin
export default {"focus":"QSUlZ"};